import { render } from "./pb-heading.vue?vue&type=template&id=76d776ef"
import script from "./pb-heading.vue?vue&type=script&lang=js"
export * from "./pb-heading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__